import React from 'react';
import classNames from 'classnames';
import * as Immutable from 'immutable';
import ToolbarItemsList, {
    ToolbarItemsListRequiredProps,
} from '../../../../workspace/toolbar/components/ToolbarItemsList';
import { getToolbarLevel } from '../../mobileToolbarUtils';
import { getToolbarHash } from '../../../../workspace/toolbar/utils/toolbarGeneralUtils';

import { ToolbarList } from '../../../../workspace/toolbar/toolbarTypes';

import './MobileToolbarItemsList.scss';

const EMPTY_LIST = Immutable.List<string>();

type MobileToolbarToolListProps = {
    toolList: ToolbarList;
    debouncedProps: ToolbarItemsListRequiredProps;
    gridSize: number;
    gridSizeName: string;
    utilityItem?: React.ReactNode;
};

const MobileToolbarItemsList = ({
    toolList,
    gridSize,
    gridSizeName,
    debouncedProps,
    utilityItem,
}: MobileToolbarToolListProps) => {
    // hash of rendered items is the most stable way to identify the toolbar items
    const renderedToolsId = getToolbarHash(toolList.items).toString();

    // NOTE: The class is added at this level, so that transitioning toolbars won't be affected
    //  by changes in the current toolbar's level
    const toolbarLevel = getToolbarLevel(toolList.type);

    return (
        <div className={classNames('MobileToolbarItemsList', `toolbar-level-${toolbarLevel}`)}>
            <div className="scrollable-tool-list-container">
                <div
                    className="scrollable-tool-list"
                    style={
                        {
                            '--tool-count': toolList.items.length,
                        } as React.CSSProperties
                    }
                >
                    <ToolbarItemsList
                        getComponent={(item) => item.mobileComponent || item.component}
                        toolListId={renderedToolsId}
                        items={toolList.items}
                        currentUser={debouncedProps.currentUser}
                        currentUserId={debouncedProps.currentUserId}
                        currentBoardId={debouncedProps.currentBoardId}
                        gridSize={gridSize}
                        gridSizeName={gridSizeName}
                        permissions={toolList.capturedState?.permissions || 0}
                        selectedElementIds={toolList.capturedState?.selectedElementIds || EMPTY_LIST}
                        editorKey={toolList.capturedState?.editorKey}
                        hasEditorSelection={toolList.capturedState?.hasEditorSelection || false}
                    />
                </div>
            </div>
            {utilityItem && <div className="utility-item">{utilityItem}</div>}
        </div>
    );
};

export default MobileToolbarItemsList;
